<template>
  <div id="merchant-page">
    <div class="flex items-center justify-between mb-4">
      <h2>{{$t('Holidays')}}</h2>
      <span class="font-medium text-primary cursor-pointer">
        <vs-button @click="openHolidayModal('add')" color="primary" icon-pack="feather" icon="icon-plus" size="large">
        </vs-button>
      </span>
    </div>

    <shipblu-table
      :sst="true"
      multiple
      v-model="selected"
      pagination
      :max-items="maximumItems"
      :data="holidays"
      :tableLoader="tableLoader"
      :hideHeader="true"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between"></div>
      <template slot="thead">
        <shipblu-th>{{$t('Date')}}</shipblu-th>
        <shipblu-th>{{$t('Applies To')}}</shipblu-th>
        <shipblu-th class="order-1 flex justify-center">
          <feather-icon icon="ChevronDownIcon" svgClasses="h-5 w-5"/>
        </shipblu-th>
      </template>

      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <shipblu-td class="order-3" :data="data[indextr].date">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Date')}}</p>
            <p class="sm:text-base text-sm">
            {{ data[indextr].date }}
            </p>
          </shipblu-td>

          <shipblu-td class="order-4" :data="data[indextr].apllies">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Applies To')}}</p>
            <p class="sm:text-base text-sm" v-for="item in data[indextr].applies_to" :key="item.index">{{ item }}</p>
          </shipblu-td>

          <shipblu-td class="order-2" style="vertical-align: middle;">
            <div class="md:text-center text-right">
              <vs-dropdown
                vs-trigger-click
                @click="selected = []"
                class="dd-actions cursor-pointer"
              >
                <span class="material-symbols-outlined text-2xl">more_horiz</span>
                <vs-dropdown-menu style="width: 190px">
                  <vs-dropdown-item  @click="deleteHoliday(data[indextr])">
                    <span class="flex items-center">
                      <feather-icon
                        icon="TrashIcon"
                        svgClasses="h-4 w-4"
                        class="mr-2"
                      />
                      <span>{{$t('Delete')}}</span>
                    </span>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-pagination :maximumItems="maximumItems" :noOptions="true" :totalRows="totalRows" :currentPage="currentPage" @currentPage="currentPage = $event" />
    <add-holiday :holiday="holiday" :holidayModal="holidayModal" @holidayModal="holidayModal = $event" @loadHolidays="loadHolidays"></add-holiday>
  </div>
</template>

<script>
import { sendRequest }  from '../../http/axios/requestHelper.js'
import ShipbluTable from '../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import AddHoliday from './components/AddHoliday.vue'
import i18nData from '../../i18n/i18nData.js'
import ShipbluPagination from '../../layouts/components/ShipbluPagination.vue'

export default {
  data () {
    return {
      selected: [],
      maximumItems: process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      holidays: [],
      holidayModal: false,
      offset: 0,
      totalRows: 0,
      tableLoader: false,
      currentPage: (this.$route.query.page &&  Number(this.$route.query.page) > 0) ? Number(this.$route.query.page) : 1,
      deleteData: {},
      holiday: {}
    }
  },
  watch: {
    currentPage () {
      this.offset = (this.currentPage - 1) * this.maximumItems
      this.$router.push({
        query: {
          page: this.currentPage
        }
      }).catch(() => {})
      this.loadHolidays()
    }
  },
  methods: {
    loadHolidays () {
      this.tableLoader = true
      const query = `?offset=${this.offset}&limit=${this.maximumItems}`
      sendRequest(true, false, this, `api/v1/task-sheets/holidays/${query}`, 'get', null, true,
        (response) => {
          this.holidays = response.data.results
          this.totalRows = response.data.count
          this.tableLoader = false
        }
      )
    },
    openHolidayModal () {
      this.holidayModal = true
      this.holiday = {
        date: ''
      }
    },
    deleteHoliday (data) {
      this.deleteData = data
      this.$vs.dialog({
        color: 'danger',
        title: 'Confirm',
        text: i18nData[this.$i18n.locale]['Are you sure to delete?'],
        accept: this.confirmDelete
      })
    },
    confirmDelete () {
      sendRequest(false, false, this, `api/v1/task-sheets/holidays/${this.deleteData.id}/`, 'delete', null, true,
        () => {
          this.loadHolidays()
        }
      )
    }
  },
  created () {
    this.offset = (this.currentPage - 1) * this.maximumItems
    this.loadHolidays()
  },
  components: {
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    AddHoliday,
    ShipbluPagination
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table{
  display: none;
}
</style>
